import { render, staticRenderFns } from "./SnapsheetsTemplatesContainer.vue?vue&type=template&id=3ed38a1c&scoped=true&"
import script from "./SnapsheetsTemplatesContainer.vue?vue&type=script&lang=js&"
export * from "./SnapsheetsTemplatesContainer.vue?vue&type=script&lang=js&"
import style0 from "./SnapsheetsTemplatesContainer.vue?vue&type=style&index=0&id=3ed38a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed38a1c",
  null
  
)

export default component.exports